import {
    updateBookpart,
    generateBookpart,
    checkBookpartGenerationState,
    fetchBookpart
} from '../api/bookpart';

import { socket, getSocketConnectionData as wsConnection } from '@speechki-frontend/core/socket';

import { getToken } from '@speechki-frontend/core/auth/utils';

const defaultParams = {
    interval: 5000,
    timeout: 90000
};
const ERROR_MESSAGE = [
    {
        detail: 'Generation error, please try again'
    }
];
const TIMEOUT_ERROR_MESSAGE = [
    {
        detail: 'Generation is taking longer than expected, please refresh the page later'
    }
];

export const updateAndGenerate = async (id, data, params = defaultParams) => {
    try {
        await updateBookpart(id, data);
        const bookpart = await generate(id, params);
        return bookpart;
    } catch (e) {
        console.log(e);
        throw e;
    }
};

export const generate = async (id, params = defaultParams) => {
    await generateBookpart(id);

    let promiseResolve, promiseReject, pollInterval, timeoutId;
    window.onbeforeunload = () => {
        clearInterval(pollInterval);
        clearTimeout(timeoutId);
    };

    const client = socket(wsConnection(getToken()));

    client.receiver.on('record_process_book_part_update', handleMessage);

    const off = () => {
        client.receiver.off('record_process_book_part_update', handleMessage);
    };

    const cleanup = () => {
        clearInterval(pollInterval);
        pollInterval = null;
        clearTimeout(timeoutId);
        timeoutId = null;
        off();
    };

    async function handleMessage({ code, params = {} }) {
        cleanup();

        if (params.action === 'generate' && code === 200) {
            const [generatedId] = params.extra_data.bp_ids;

            if (id === generatedId) {
                const updated = await fetchBookpart(id);

                return promiseResolve(updated);
            }
        }

        return promiseReject(ERROR_MESSAGE);
    }

    const promise = new Promise(async (resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;

        // overall timeout for the whole generation wait (WS + polling),
        // so the UI never hangs forever if neither channel responds
        timeoutId = setTimeout(() => {
            cleanup();
            reject(TIMEOUT_ERROR_MESSAGE);
        }, params.timeout || defaultParams.timeout);

        pollInterval = setInterval(async () => {
            const { inQueue } = await checkBookpartGenerationState(id);

            if (!inQueue) {
                cleanup();

                const updated = await fetchBookpart(id);

                const error = updated.error_message;

                if (error) {
                    reject([
                        {
                            detail: error || 'Generation error, please try again'
                        }
                    ]);
                }

                resolve(updated);
            }
        }, params.interval);
    });

    return promise;
};
